import Vue from "vue";
import Router from "vue-router";
import Layout from "./views/layouts/Base.vue";

Vue.use(Router);

export default new Router({
  mode: process.env.NODE_ENV === "serve" ? "hash" : "history",
  routes: [
    { path: "/email", component: () => import("@/views/h5/email") },
    { path: "/done", component: () => import("@/views/h5/done") },
    { path: "/sent", component: () => import("@/views/h5/sent") },
    { path: "/unlock", component: () => import("@/views/h5/unlock") },
    {
      path: "/unlock-complete",
      component: () => import("@/views/h5/unlock-complete")
    },
    {
      path: "/",
      component: Layout,
      redirect: "",
      children: [
        {
          path: "",
          name: "Index",
          component: () => import("@/views/Transfer")
        },
        {
          path: "link/:code",
          name: "ShareLink",
          props: { transferType: 2 },
          component: () => import("@/views/share/Index")
        },
        {
          path: "transfer/:code",
          name: "ShareTransfer",
          props: { transferType: 1 },
          component: () => import("@/views/share/Index")
        },
        {
          path: "reset-password",
          name: "ResetPassword",
          component: () => import("@/views/account/ResetPassword")
        },
        {
          path: "terms",
          name: "Terms",
          component: () => import("@/views/Terms")
        },
        {
          path: "privacy-policy",
          name: "PrivacyPolicy",
          component: () => import("@/views/PrivacyPolicy")
        },
        {
          path: "faqs",
          name: "Faqs",
          component: () => import("@/views/Faqs")
        },
        { path: "/404", component: () => import("@/views/404") },
        { path: "*", redirect: "/404" }
      ]
    }
    // { path: "*", redirect: "/404" }
  ]
});
